const parser = (version) => {
  const [major, minor, patch] = version.split('.');
  return { major, minor, patch };
};

class VersionCompare {
  constructor(v1, v2) {
    this.v1 = parser(v1);
    this.v2 = parser(v2);
  }

  isNewer() {
    if (this.v1.major > this.v2.major) {
      return true;
    }
    if (this.v1.major === this.v2.major && this.v1.minor > this.v2.minor) {
      return true;
    }
    if (
      this.v1.major === this.v2.major &&
      this.v1.minor === this.v2.minor &&
      this.v1.patch > this.v2.patch
    ) {
      return true;
    }
    return false;
  }
}

export default VersionCompare;
